import React from "react";
import styles from "./checkbox.module.css";

export default function Checkbox({ value, setValue, text }) {
    return (
        <div className={styles["checker"]} onClick={() => setValue()}>
            <i className={`fi ${value === true ? "fi-rr-checkbox" : "fi-rr-square"}`} />
            <span>{text}</span>
        </div>
    );
}
